export const CHECKOUT_URL =
  'https://metodo-maestro-amigurumi.impultienda.ar/checkout'

export const PRICE = 11990
export const PRICE_LABEL = '$11.990'

export const skills = [
  {
    title: 'El Idioma del Crochet',
    description:
      'Aprendé a leer patrones y diagramas como una experta. Nunca más vas a depender de un video.',
  },
  {
    title: 'Técnica Invisible',
    description:
      'Lográ puntos firmes y parejos para que no se vea el relleno.',
  },
  {
    title: 'Escultura con Lana',
    description:
      'Secretos de costura y articulación para que tus muñecos tengan expresiones reales y tiernas.',
  },
  {
    title: 'Materiales Pro',
    description:
      'Guía de qué comprar en Argentina para ahorrar dinero y obtener la mejor calidad.',
  },
]

export const painPoints = [
  'Videos mal explicados que ocultan los detalles importantes.',
  'Patrones mal traducidos que confunden a cualquiera.',
  'Técnicas de relleno que dejan a tus muñecos “flojos” y sin vida.',
]

export type PackItem = {
  label: string
  name: string
  detail: string
  value: number
  isBonus: boolean
}

export const packItems: PackItem[] = [
  {
    label: '📘',
    name: 'El Manual Maestro Amigurumi',
    detail: 'Paso a paso ilustrado',
    value: 15000,
    isBonus: false,
  },
  {
    label: '🎁',
    name: 'BONO 1: Diccionario Universal de Puntos',
    detail: 'Puntos y abreviaturas, en español',
    value: 4500,
    isBonus: true,
  },
  {
    label: '🎁',
    name: 'BONO 2: Guía de Materiales Recomendados',
    detail: 'Qué comprar y dónde, sin gastar de más',
    value: 5000,
    isBonus: true,
  },
  {
    label: '🎁',
    name: 'BONO 3: Los 5 Patrones de Práctica',
    detail: 'Nivel inicial a pro, paso a paso',
    value: 3000,
    isBonus: true,
  },
]

export const faqs = [
  {
    question: '¿Necesito saber tejer antes?',
    answer:
      'Absolutamente no. Empezamos desde cómo sostener la aguja. Es ideal para principiantes totales.',
  },
  {
    question: '¿Cómo recibo el material?',
    answer:
      'Apenas realices el pago, recibís un mail con el acceso inmediato a todo el contenido digital para descargar en tu celular o compu.',
  },
  {
    question: '¿Tengo que comprar materiales caros?',
    answer:
      'No. En la guía te enseñamos cómo empezar con lo básico que podés encontrar en cualquier mercería de barrio.',
  },
]

export const formatArs = (value: number) =>
  '$' + value.toLocaleString('es-AR')
